/*
*
* File JS componente Breadcrumbs
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './breadcrumbs.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const breadcrumbs = () => {

    let elIconBreadcrumbs = document.querySelector('#icon-breadcrumbs');

    if (!elIconBreadcrumbs) return;

    let tagIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-nav-home"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#nav-home"></use></svg>';

    elIconBreadcrumbs.innerHTML = elIconBreadcrumbs.innerHTML + tagIcon;
}

export default breadcrumbs;

//--------------------------------------------------------------------//